import React, { ReactNode } from 'react'
import { useConsumerAmount, useCrossBorderTrade, useMerchantAmount } from '../../state'
import { Text } from '@afterpaytouch/core'
import { Trans } from '../../utils/convergence'
import styles from './styles.module.css'

export const CrossBorderToastMessage = (): ReactNode => {
  const { isCrossBorder, exchangeRate } = useCrossBorderTrade()
  const consumerAmount = useConsumerAmount()
  const merchantAmount = useMerchantAmount()

  if (!isCrossBorder || exchangeRate === undefined) {
    return null
  }

  return (
    <Text size='XS'>
      <Trans
        i18nKey='summary:crossBorderTradeToast.message'
        values={{
          consumerSymbol: consumerAmount?.symbol,
          consumerCurrency: consumerAmount?.currency,
          merchantSymbol: merchantAmount?.symbol,
          merchantCurrency: merchantAmount?.currency,
          exchangeRate,
        }}
        components={{
          wrapHandler: <div className={styles.wrapHandler} />,
        }}
      />
    </Text>
  )
}
